import { render, staticRenderFns } from "./IcoArrowLink.vue?vue&type=template&id=2ab80240&lang=pug&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports